import { jsx as _jsx } from "react/jsx-runtime";
import { useMediaQuery, useTheme } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { CircleSelect } from './circle-select.component';
import { BsCheck2, BsX } from 'react-icons/bs';
import { palette } from '@/theme/palette';
export function PerceivedHearingStatusContent() {
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });
    var control = useFormContext().control;
    return (_jsx(CircleSelect, { controllerProps: {
            name: 'hearing-loss',
            control: control,
            rules: {
                required: 'Please select an option',
            },
        }, itemStyles: {
            boxShadow: "0 0 4px 2px ".concat(palette.shadow.main),
            border: '3px solid var(--circle-select-color)',
            svg: {
                stroke: 'var(--circle-select-color)',
                strokeWidth: 1.5,
                width: isMobile ? '2.5rem' : '3.75rem',
                height: isMobile ? '2.5rem' : '3.75rem',
            },
            '&[data-state="checked"]': {
                svg: { stroke: 'white' },
                border: '3px solid white',
            },
            width: isMobile ? '3.75rem' : '5.625rem',
            height: isMobile ? '3.75rem' : '5.625rem',
            margin: isMobile ? '0.75rem' : '1rem',
        }, options: [
            {
                label: 'Yes',
                value: 'yes',
                icon: _jsx(BsCheck2, {}),
            },
            {
                label: 'No',
                value: 'no',
                icon: _jsx(BsX, {}),
            },
        ] }));
}
